import { i18n } from '../../../helper/i18n'
import { capitalize } from '../../../utils/string'

export default function parseActions(self, actions = []) {
  return actions.map(action => {
    if (typeof action === 'string') {
      const label = i18n(capitalize(action))
      if (action === 'edit') {
        return {
          label,
          click: self.editHandler.bind(self),
          hide: action.hide
        }
      } else if (action === 'detail') {
        return {
          label,
          click: self.detailHandler.bind(self),
          hide: action.hide
        }
      } else if (action === 'delete') {
        return {
          label,
          click: self.deleteHandler.bind(self),
          hide: action.hide
        }
      }
    } else if (typeof action === 'object') {
      // no need i18n here, let users do their own
      if (action.click === 'edit') {
        return {
          label: action.label,
          click: self.editHandler.bind(self),
          hide: action.hide
        }
      } else if (action.click === 'detail') {
        return {
          label: action.label,
          click: self.detailHandler.bind(self),
          hide: action.hide
        }
      } else if (action.click === 'delete') {
        return {
          label: action.label,
          click: self.deleteHandler.bind(self),
          hide: action.hide
        }
      }
      return {
        label: action.label,
        click: action.click.bind(self),
        hide: action.hide
      }
    }
  })
}



// WEBPACK FOOTER //
// ./packages/creator/common/dataParse/actions.js